import React, { useCallback } from 'react';
import styles from './Created.module.css';
import { CreatedElement, CreatedElementInterface } from '../CreatedElement';

export const DesktopView = (): JSX.Element => {
  // Redux Hooks

  const createdElement: CreatedElementInterface = CreatedElement();
  return (
    <React.Fragment>
      <div className={styles.profileCreatedTitleDiv} id="profile-created-title">
        <b
          className={styles.profileCreatedTitleTextB}
          id="profile-created-title-text"
        >
          profile created!
        </b>
      </div>
      <div
        className={styles.profileCreatedMainGroupDiv}
        id="profile-created-main-group"
      >
        <div
          className={styles.profileCreatedMainContentDiv}
          id="profile-created-main-content"
        >
          {createdElement.avatar}
          <b
            className={styles.profileCreatedTitleTextB}
            id="profile-created-main-content-name"
          >
            {createdElement.childNameLabel}
          </b>
        </div>
      </div>
      <div
        className={styles.profileCreatedFooterDiv}
        id="profile-created-footer"
      >
        <div className={styles.createChildProfileMainGrouButton}>
          {createdElement.backButton}
        </div>
        <div
          className={styles.createChildProfileMainGrouButton1}
          id="create-child-profile-main-group-next-button"
        >
          {createdElement.nextButton}
        </div>
      </div>
    </React.Fragment>
  );
};
